import {
  createAsyncThunk,
  createSlice,
  isRejectedWithValue,
} from "@reduxjs/toolkit";
import { API_PATH } from "../api/apiPath";
import { deleteApi, getApi, postApi, putApi } from "../api/axiosInstance";

const handleApiError = (error) => {
  return isRejectedWithValue(error.response?.data ?? "Unknown Error");
};

export const fetchVerifiedSalons = createAsyncThunk(
  "admin/get-verified-business",
  async (b) => {
    const { currentPage, filter } = b;
    const payload = {
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_VERIFIED_SALONS}/${currentPage}`,
        payload
      );
      const salons = response.data.data;
      return salons;
    } catch (error) {
      return handleApiError(error);
    }
  }
);
export const fetchRequestSalons = createAsyncThunk(
  "admin/get-business-request",
  async (b) => {
    const { currentPage, filter } = b;
    const payload = {
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_SALONS_REQUEST}/${currentPage}`,
        payload
      );
      const salons = response.data.data;
      return salons;
    } catch (error) {
      return handleApiError(error);
    }
  }
);
export const fetchUsers = createAsyncThunk("admin/get-all-users", async (b) => {
  const { currentPage, filter } = b;
  const payload = {
    status: filter,
  };
  try {
    const response = await postApi(
      `${API_PATH.ADMIN.GET_USERS}/${currentPage}`,
      payload
    );
    const salons = response.data.data;
    return salons;
  } catch (error) {
    return handleApiError(error);
  }
});
export const fetchAdminProfile = createAsyncThunk(
  "admin/my-profile",
  async () => {
    try {
      const response = await getApi(API_PATH.ADMIN.GET_ADMIN_PROFILE);
      const profile = response.data.data.user;
      return profile;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//  thunk for salon details
export const fetchSalonDetails = createAsyncThunk(
  "admin/get-business-details",
  async (salonId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_SALON_DETAILS}/${salonId}`
      );
      const salonDetails = response.data.data;
      return salonDetails;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//  thunk for user details
export const fetchUserDetails = createAsyncThunk(
  "admin/get-user-details",
  async (userId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_USER_DETAILS}/${userId}`
      );
      const userDetails = response.data.data;
      return userDetails;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting staff
export const fetchBusinessStaff = createAsyncThunk(
  "admin/get-business-staff",
  async (salonId) => {
    console.log(salonId)
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_BUSINESS_STAFF}/${salonId}`
      );
      const staff = response.data.data;
      return staff;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting staff
export const fetchBusinessStaffBooking = createAsyncThunk(
  "admin/get-business-staffs",
  async (salonId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_BUSINESS_STAFF}/${salonId}`
      );
      const staff = response.data.data;
      return staff;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting business booking
export const fetchBusinessBooking = createAsyncThunk(
  "admin/get-business-bookings",
  async (b) => {
    const { currentPage, filter, salonId } = b;
    const payload = {
      id: salonId,
      page: currentPage,
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_BUSINESS_BOOKINGS}`,
        payload
      );
      const bookings = response.data.data;
      return bookings;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting user bookings
export const fetchUserBooking = createAsyncThunk(
  "admin/get-user-bookings",
  async (b) => {
    const { currentPage, filter, userId } = b;
    const payload = {
      id: userId,
      page: currentPage,
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_USER_BOOKINGS}`,
        payload
      );
      const bookings = response.data.data;
      return bookings;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//  thunk for bookings list
export const fetchBookingList = createAsyncThunk(
  "admin/get-all-bookings",
  async (b) => {
    const { currentPage, filter } = b;
    const payload = {
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_ALL_BOOKINGS}/${currentPage}`,
        payload
      );
      const bookings = response.data.data;
      return bookings;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//  thunk for booking details
export const fetchBookingDetails = createAsyncThunk(
  "admin/get-booking",
  async (bookingId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_BOOKING_DETAILS}/${bookingId}`
      );
      const bookingDetails = response.data.data;
      return bookingDetails;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for service list
export const fetchServices = createAsyncThunk(
  "admin/get-service-admin",
  async (currentPage) => {
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_SERVICES}/${currentPage}`
      );
      const service = response.data.data;
      return service;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for delete service
export const deleteService = createAsyncThunk(
  "/delete-services",
  async (payload) => {
    try {
      const res = await postApi(`${API_PATH.ADMIN.DELETE_SERVICE}`, payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for add service
export const addService = createAsyncThunk("/add-services", async (payload) => {
  try {
    const res = await postApi(`${API_PATH.ADMIN.ADD_SERVICE}`, payload);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for update service
export const updateService = createAsyncThunk(
  "/update-services",
  async (payload) => {
    try {
      const res = await postApi(`${API_PATH.ADMIN.UPDATE_SERVICE}`, payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting reports
export const fetchReports = createAsyncThunk(
  "report/get-reports",
  async (b) => {
    const { currentPage, filter } = b;
    const payload = {
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_REPORTS}/${currentPage}`,
        payload
      );
      const reports = response.data.data;
      return reports;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for delete report
export const deleteReport = createAsyncThunk("/delete-report", async (id) => {
  try {
    const res = await deleteApi(`${API_PATH.ADMIN.DELETE_REPORT}/${id}`);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for getting  business services
export const fetchBusinessServices = createAsyncThunk(
  "admin/get-business-services",
  async (salonId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_BUSINESS_SERVICES}/${salonId}`
      );
      const services = response.data.data;
      return services;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting  business services
export const fetchBusinessServicesBooking = createAsyncThunk(
  "admin/get-business-service",
  async (salonId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_BUSINESS_SERVICES}/${salonId}`
      );
      const services = response.data.data;
      return services;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for category list
export const fetchCategories = createAsyncThunk(
  "common/get-category-admin",
  async (currentPage) => {
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_CATEGORY}/${currentPage}`
      );
      const category = response.data.data;
      return category;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for update category
export const updateCategory = createAsyncThunk(
  "common/update-category",
  async (payload) => {
    try {
      const res = await postApi(`${API_PATH.ADMIN.UPDATE_CATEGORY}`, payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for add category
export const addCategory = createAsyncThunk(
  "common/add-category",
  async (payload) => {
    try {
      const res = await postApi(`${API_PATH.ADMIN.ADD_CATEGORY}`, payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for getting services by category
export const fetchServicesByCategory = createAsyncThunk(
  "admin/get-services-by-category",
  async (categoryId) => {
    try {
      const response = await getApi(
        `${API_PATH.ADMIN.GET_SERVICES_BY_CATEGORY}?category_id=${categoryId}`
      );
      const services = response.data.data;
      return services;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting reports
export const fetchTickets = createAsyncThunk("/get-all-tickets", async (b) => {
  const { currentPage, filter } = b;
  const payload = {
    status: filter,
  };
  try {
    const response = await postApi(
      `${API_PATH.ADMIN.GET_TICKETS}?${currentPage}`,
      payload
    );
    const tickets = response.data.data;
    return tickets;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for getting queries
export const fetchQueries = createAsyncThunk("/get-all-queries", async (b) => {
  const { currentPage, filter } = b;
  const payload = {
    status: filter,
  };
  try {
    const response = await postApi(
      `${API_PATH.ADMIN.GET_QUERIES}?${currentPage}`,
      payload
    );
    const queries = response.data.data;
    return queries;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for delete ticket
export const deleteTicket = createAsyncThunk("/delete-ticket", async (id) => {
  try {
    const res = await deleteApi(`${API_PATH.ADMIN.DELETE_TICKET}/${id}`);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for delete query
export const deleteQuery = createAsyncThunk("/delete-query", async (id) => {
  try {
    const res = await deleteApi(`${API_PATH.ADMIN.DELETE_QUERY}/${id}`);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

// thunk for faq list
export const fetchFaqs = createAsyncThunk(
  "admin/get-faq-admin",
  async (currentPage) => {
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_FAQ}/${currentPage}`
      );
      const faqs = response.data.data;
      return faqs;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for weekly offer list
export const fetchWeeklyOffer = createAsyncThunk(
  "admin/get-offer-admin",
  async (currentPage) => {
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_WEEKLY_OFFERS}/${currentPage}`
      );
      const offers = response.data.data;
      return offers;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for delete faq
export const deleteFaq = createAsyncThunk("/delete-faq", async (id) => {
  try {
    const res = await deleteApi(`${API_PATH.ADMIN.DELETE_FAQ}/${id}`);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

// thunk for update faq
export const updateFaq = createAsyncThunk(
  "faq/update-faq",
  async ({ id, question, answer }) => {
    try {
      const res = await putApi(`${API_PATH.ADMIN.UPDATE_FAQ}/${id}`, {
        question,
        answer,
      });
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

export const addFaq = createAsyncThunk("faq/add-faq", async (payload) => {
  try {
    const res = await postApi(API_PATH.ADMIN.ADD_FAQ, payload);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

// thunk for adding weekly offer
export const addWeeklyOffer = createAsyncThunk(
  "common/add-weekly-offer",
  async (payload) => {
    try {
      const res = await postApi(API_PATH.ADMIN.ADD_WEEKLY_OFFER, payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for delete weekly offer
export const deleteWeeklyOffer = createAsyncThunk(
  "common/delete-weekly-offer",
  async (id) => {
    try {
      const res = await postApi(`${API_PATH.ADMIN.DELETE_WEEKLY_OFFER}`, {
        _id: id,
      });
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for update weekly offer
export const updateWeeklyOffer = createAsyncThunk(
  "common/update-weekly-offer",
  async (payload) => {
    try {
      const res = await postApi(
        `${API_PATH.ADMIN.UPDATE_WEEKLY_OFFER}`,
        payload
      );
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for weekly offer list
export const fetchCouponCode = createAsyncThunk(
  "admin/get-all-coupon",
  async () => {
    try {
      const response = await getApi(`${API_PATH.ADMIN.GET_COUPON_CODE}`);
      const code = response.data.data;
      return code;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//  thunk for coupon list
export const fetchCouponList = createAsyncThunk(
  "admin/coupons-list",
  async (b) => {
    const { currentPage, filter } = b;
    const payload = {
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_ALL_COUPONS}/${currentPage}`,
        payload
      );
      const coupons = response.data.data;
      return coupons;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for delete coupon
export const deleteCoupon = createAsyncThunk(
  "admin/delete-coupon",
  async (id) => {
    try {
      const res = await deleteApi(`${API_PATH.ADMIN.DELETE_COUPON}/${id}`);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for add coupon
export const addCoupon = createAsyncThunk(
  "admin/add-coupon",
  async (couponData) => {
    try {
      const res = await postApi(API_PATH.ADMIN.ADD_COUPON, couponData);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for update coupon
export const updateCoupon = createAsyncThunk(
  "admin/update-coupon",
  async ({ id, couponData }) => {
    try {
      const res = await putApi(
        `${API_PATH.ADMIN.UPDATE_COUPON}/${id}`,
        couponData
      );
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for update coupon status
export const updateCouponStatus = createAsyncThunk(
  "admin/update-coupon-status",
  async (id) => {
    try {
      const res = await putApi(`${API_PATH.ADMIN.UPDATE_COUPON_STATUS}/${id}`);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for service list
export const fetchConfig = createAsyncThunk(
  "config/get-config",
  async (currentPage) => {
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_CONFIG}/${currentPage}`
      );
      const config = response.data.data;
      return config;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for delete service
export const deleteConfig = createAsyncThunk(
  "config/delete-config",
  async (id) => {
    try {
      const res = await deleteApi(`${API_PATH.ADMIN.DELETE_CONFIG}/${id}`);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for add service
export const addConfig = createAsyncThunk("config/add-services", async (payload) => {
  try {
    const res = await postApi(`${API_PATH.ADMIN.ADD_CONFIG}`, payload);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for update service
export const updateConfig = createAsyncThunk(
  "config/update-config",
  async (payload) => {
    try {
      const res = await putApi(`${API_PATH.ADMIN.UPDATE_CONFIG}/${payload._id}`, payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for update config status
export const updateConfigStatus = createAsyncThunk(
  "config/update-config-status",
  async (id) => {
    try {
      const res = await putApi(`${API_PATH.ADMIN.UPDATE_CONFIG_STATUS}/${id}`);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for user stats
export const fetchUserStats = createAsyncThunk(
  "admin/user-stats",
  async (payload) => {
    try {
      const response = await postApi(`${API_PATH.ADMIN.USER_STATS}`, payload);
      const stats = response.data.data;
      return stats;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for admin stats
export const fetchAdminStats = createAsyncThunk(
  "admin/stats",
  async () => {
    try {
      const response = await getApi(`${API_PATH.ADMIN.ADMIN_STATS}`);
      const stats = response.data.data;
      return stats;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for dashboard graphs
export const fetchDashGraph = createAsyncThunk(
  "admin/earnings-dashboard",
  async (year) => {
    try {
      const selectYear = year;
      const response = await postApi(`${API_PATH.ADMIN.GRAPH_DATA}`,{year: selectYear});
      const stats = response.data.data;
      return stats;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for payments list
export const fetchPaymentList = createAsyncThunk(
  "admin/payments",
  async (b) => {
    const { currentPage, filter } = b;
    const payload = {
      status: filter,
    };
    try {
      const response = await postApi(
        `${API_PATH.ADMIN.GET_PAYMENTS}/${currentPage}`,
        payload
      );
      const payments = response.data.data;
      return payments;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for update offer status
export const updateOfferStatus = createAsyncThunk(
  "common/publish-weekly-offer",
  async (payload) => {
    try {
      const res = await postApi(`${API_PATH.ADMIN.UPDATE_OFFER_STATUS}`,payload);
      return res.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

//thunk for getting complaints
export const fetchComplaints = createAsyncThunk("complaint/get-all-complaint", async (b) => {
  const { currentPage, filter } = b;
  const payload = {
    status: filter,
  };
  try {
    const response = await postApi(
      `${API_PATH.ADMIN.GET_COMPLAINTS}?${currentPage}`,
      payload
    );
    const complaints = response.data.data;
    return complaints;
  } catch (error) {
    return handleApiError(error);
  }
});

//thunk for delete complaint
export const deleteComplaint = createAsyncThunk("/delete-complaint", async (id) => {
  try {
    const res = await deleteApi(`${API_PATH.ADMIN.DELETE_COMPLAINT}/${id}`);
    return res.data;
  } catch (error) {
    return handleApiError(error);
  }
});

// thunk for business list for dummy boking
export const fetchBusiness = createAsyncThunk(
  "admin/get-all-business",
  async () => {
    try {
      const response = await getApi(`${API_PATH.ADMIN.GET_BUSINESS}`);
      const salons = response.data.data;
      return salons;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

// thunk for users list for dummy boking
export const fetchUser = createAsyncThunk(
  "admin/get-users",
  async () => {
    try {
      const response = await getApi(`${API_PATH.ADMIN.GET_USERS_BOOKING}`);
      const users = response.data.data;
      return users;
    } catch (error) {
      return handleApiError(error);
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    verifiedSalons: {
      data: [],
      status: "idle",
      error: null,
    },
    requestSalons: {
      data: [],
      status: "idle",
      error: null,
    },
    users: {
      data: [],
      status: "idle",
      error: null,
    },
    admin: {
      profile: [],
      loading: false,
      error: null,
    },
    //  state for salon details
    salonDetails: {
      data: null,
      status: "idle",
      error: null,
    },
    //  state for salon details
    userDetails: {
      data: null,
      status: "idle",
      error: null,
    },
    //state for business staff
    staff: {
      data: null,
      status: "idle",
      error: null,
    },
    //state for business staff
    staffBooking: {
      data: null,
      status: "idle",
      error: null,
    },
    //state for business bookings
    businessBookings: {
      data: null,
      status: "idle",
      error: null,
    },
    //state for user bookings
    userBookings: {
      data: null,
      status: "idle",
      error: null,
    },
    //state for all bookings
    bookings: {
      data: null,
      status: "idle",
      error: null,
    },
    //  state for booking details
    bookingDetails: {
      data: null,
      status: "idle",
      error: null,
    },
    //  state for service list
    services: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for report list
    reports: {
      data: [],
      status: "idle",
      error: null,
    },
    //state for business services
    businessServices: {
      data: null,
      status: "idle",
      error: null,
    },
    //state for business services
    businessServicesBookings: {
      data: null,
      status: "idle",
      error: null,
    },
    //  state for category list
    categories: {
      data: [],
      status: "idle",
      error: null,
    },
    //state for service related to category
    categoryServices: {
      data: null,
      status: "idle",
      error: null,
    },
    //  state for tickets list
    tickets: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for query list
    queries: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for faq list
    faqs: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for weekly offer list
    offers: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for coupon code list
    codes: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for coupons list
    coupons: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for config list
    configs: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for user stat
    userStats: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for admin stat
    stats: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for graph data
    graphStats: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for payment data
    payments: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for complaint list
    complaints: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for salon list for dummy bookings
    salonList: {
      data: [],
      status: "idle",
      error: null,
    },
    //  state for user list for dummy bookings
    userList: {
      data: [],
      status: "idle",
      error: null,
    },
  },
  extraReducers: (builder) => {
    // Verified Salons cases
    builder
      .addCase(fetchVerifiedSalons.pending, (state) => {
        state.verifiedSalons.status = "loading";
      })
      .addCase(fetchVerifiedSalons.fulfilled, (state, action) => {
        state.verifiedSalons.status = "succeeded";
        state.verifiedSalons.data = action.payload;
      })
      .addCase(fetchVerifiedSalons.rejected, (state, action) => {
        state.verifiedSalons.status = "failed";
        state.verifiedSalons.error = action.error.message;
      });

    //salon request
    builder
      .addCase(fetchRequestSalons.pending, (state) => {
        state.requestSalons.status = "loading";
      })
      .addCase(fetchRequestSalons.fulfilled, (state, action) => {
        state.requestSalons.status = "succeeded";
        state.requestSalons.data = action.payload;
      })
      .addCase(fetchRequestSalons.rejected, (state, action) => {
        state.requestSalons.status = "failed";
        state.requestSalons.error = action.error.message;
      });
    //user
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.users.status = "loading";
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.users.status = "succeeded";
        state.users.data = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.users.status = "failed";
        state.users.error = action.error.message;
      });
    //admin
    builder
      .addCase(fetchAdminProfile.pending, (state) => {
        state.admin.loading = true;
      })
      .addCase(fetchAdminProfile.fulfilled, (state, action) => {
        state.admin.loading = false;
        state.admin.profile = action.payload;
      })
      .addCase(fetchAdminProfile.rejected, (state, action) => {
        state.admin.loading = false;
        state.admin.error = action.error.message;
      });

    //  salon details
    builder
      .addCase(fetchSalonDetails.pending, (state) => {
        state.salonDetails.status = "loading";
      })
      .addCase(fetchSalonDetails.fulfilled, (state, action) => {
        state.salonDetails.status = "succeeded";
        state.salonDetails.data = action.payload;
      })
      .addCase(fetchSalonDetails.rejected, (state, action) => {
        state.salonDetails.status = "failed";
        state.salonDetails.error = action.error.message;
      });
    //  user details
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.userDetails.status = "loading";
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.userDetails.status = "succeeded";
        state.userDetails.data = action.payload;
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.userDetails.status = "failed";
        state.userDetails.error = action.error.message;
      });
    //  business staff details
    builder
      .addCase(fetchBusinessStaff.pending, (state) => {
        state.staff.status = "loading";
      })
      .addCase(fetchBusinessStaff.fulfilled, (state, action) => {
        state.staff.status = "succeeded";
        state.staff.data = action.payload;
      })
      .addCase(fetchBusinessStaff.rejected, (state, action) => {
        state.staff.status = "failed";
        state.staff.error = action.error.message;
      });
      //  business staff details
    builder
      .addCase(fetchBusinessStaffBooking.pending, (state) => {
        state.staffBooking.status = "loading";
      })
      .addCase(fetchBusinessStaffBooking.fulfilled, (state, action) => {
        state.staffBooking.status = "succeeded";
        state.staffBooking.data = action.payload;
      })
      .addCase(fetchBusinessStaffBooking.rejected, (state, action) => {
        state.staffBooking.status = "failed";
        state.staffBooking.error = action.error.message;
      });
    //  business bookings details
    builder
      .addCase(fetchBusinessBooking.pending, (state) => {
        state.businessBookings.status = "loading";
      })
      .addCase(fetchBusinessBooking.fulfilled, (state, action) => {
        state.businessBookings.status = "succeeded";
        state.businessBookings.data = action.payload;
      })
      .addCase(fetchBusinessBooking.rejected, (state, action) => {
        state.businessBookings.status = "failed";
        state.businessBookings.error = action.error.message;
      });
    //  user bookings details
    builder
      .addCase(fetchUserBooking.pending, (state) => {
        state.userBookings.status = "loading";
      })
      .addCase(fetchUserBooking.fulfilled, (state, action) => {
        state.userBookings.status = "succeeded";
        state.userBookings.data = action.payload;
      })
      .addCase(fetchUserBooking.rejected, (state, action) => {
        state.userBookings.status = "failed";
        state.userBookings.error = action.error.message;
      });
    //  all bookings
    builder
      .addCase(fetchBookingList.pending, (state) => {
        state.bookings.status = "loading";
      })
      .addCase(fetchBookingList.fulfilled, (state, action) => {
        state.bookings.status = "succeeded";
        state.bookings.data = action.payload;
      })
      .addCase(fetchBookingList.rejected, (state, action) => {
        state.bookings.status = "failed";
        state.bookings.error = action.error.message;
      });
    //  booking details
    builder
      .addCase(fetchBookingDetails.pending, (state) => {
        state.bookingDetails.status = "loading";
      })
      .addCase(fetchBookingDetails.fulfilled, (state, action) => {
        state.bookingDetails.status = "succeeded";
        state.bookingDetails.data = action.payload;
      })
      .addCase(fetchBookingDetails.rejected, (state, action) => {
        state.bookingDetails.status = "failed";
        state.bookingDetails.error = action.error.message;
      });
    //  service list
    builder
      .addCase(fetchServices.pending, (state) => {
        state.services.status = "loading";
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.services.status = "succeeded";
        state.services.data = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.services.status = "failed";
        state.services.error = action.error.message;
      });
    //  report list
    builder
      .addCase(fetchReports.pending, (state) => {
        state.reports.status = "loading";
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        state.reports.status = "succeeded";
        state.reports.data = action.payload;
      })
      .addCase(fetchReports.rejected, (state, action) => {
        state.reports.status = "failed";
        state.reports.error = action.error.message;
      });
    //  business services details
    builder
      .addCase(fetchBusinessServices.pending, (state) => {
        state.businessServices.status = "loading";
      })
      .addCase(fetchBusinessServices.fulfilled, (state, action) => {
        state.businessServices.status = "succeeded";
        state.businessServices.data = action.payload;
      })
      .addCase(fetchBusinessServices.rejected, (state, action) => {
        state.businessServices.status = "failed";
        state.businessServices.error = action.error.message;
      });
      //  business services details
    builder
      .addCase(fetchBusinessServicesBooking.pending, (state) => {
        state.businessServicesBookings.status = "loading";
      })
      .addCase(fetchBusinessServicesBooking.fulfilled, (state, action) => {
        state.businessServicesBookings.status = "succeeded";
        state.businessServicesBookings.data = action.payload;
      })
      .addCase(fetchBusinessServicesBooking.rejected, (state, action) => {
        state.businessServicesBookings.status = "failed";
        state.businessServicesBookings.error = action.error.message;
      });
    //  category list
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.categories.status = "loading";
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categories.status = "succeeded";
        state.categories.data = action.payload;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.categories.status = "failed";
        state.categories.error = action.error.message;
      });
    //  category service details
    builder
      .addCase(fetchServicesByCategory.pending, (state) => {
        state.categoryServices.status = "loading";
      })
      .addCase(fetchServicesByCategory.fulfilled, (state, action) => {
        state.categoryServices.status = "succeeded";
        state.categoryServices.data = action.payload;
      })
      .addCase(fetchServicesByCategory.rejected, (state, action) => {
        state.categoryServices.status = "failed";
        state.categoryServices.error = action.error.message;
      });
    //  tickets list
    builder
      .addCase(fetchTickets.pending, (state) => {
        state.tickets.status = "loading";
      })
      .addCase(fetchTickets.fulfilled, (state, action) => {
        state.tickets.status = "succeeded";
        state.tickets.data = action.payload;
      })
      .addCase(fetchTickets.rejected, (state, action) => {
        state.tickets.status = "failed";
        state.tickets.error = action.error.message;
      });
    //  queries list
    builder
      .addCase(fetchQueries.pending, (state) => {
        state.queries.status = "loading";
      })
      .addCase(fetchQueries.fulfilled, (state, action) => {
        state.queries.status = "succeeded";
        state.queries.data = action.payload;
      })
      .addCase(fetchQueries.rejected, (state, action) => {
        state.queries.status = "failed";
        state.queries.error = action.error.message;
      });
    //  faq list
    builder
      .addCase(fetchFaqs.pending, (state) => {
        state.faqs.status = "loading";
      })
      .addCase(fetchFaqs.fulfilled, (state, action) => {
        state.faqs.status = "succeeded";
        state.faqs.data = action.payload;
      })
      .addCase(fetchFaqs.rejected, (state, action) => {
        state.faqs.status = "failed";
        state.faqs.error = action.error.message;
      });
    //  weekly offer list
    builder
      .addCase(fetchWeeklyOffer.pending, (state) => {
        state.offers.status = "loading";
      })
      .addCase(fetchWeeklyOffer.fulfilled, (state, action) => {
        state.offers.status = "succeeded";
        state.offers.data = action.payload;
      })
      .addCase(fetchWeeklyOffer.rejected, (state, action) => {
        state.offers.status = "failed";
        state.offers.error = action.error.message;
      });
    //  coupon code list
    builder
      .addCase(fetchCouponCode.pending, (state) => {
        state.codes.status = "loading";
      })
      .addCase(fetchCouponCode.fulfilled, (state, action) => {
        state.codes.status = "succeeded";
        state.codes.data = action.payload;
      })
      .addCase(fetchCouponCode.rejected, (state, action) => {
        state.codes.status = "failed";
        state.codes.error = action.error.message;
      });
    //  coupon list
    builder
      .addCase(fetchCouponList.pending, (state) => {
        state.coupons.status = "loading";
      })
      .addCase(fetchCouponList.fulfilled, (state, action) => {
        state.coupons.status = "succeeded";
        state.coupons.data = action.payload;
      })
      .addCase(fetchCouponList.rejected, (state, action) => {
        state.coupons.status = "failed";
        state.coupons.error = action.error.message;
      });
      //  config list
    builder
      .addCase(fetchConfig.pending, (state) => {
        state.configs.status = "loading";
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.configs.status = "succeeded";
        state.configs.data = action.payload;
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.configs.status = "failed";
        state.configs.error = action.error.message;
      });
       //  user stats
    builder
      .addCase(fetchUserStats.pending, (state) => {
        state.userStats.status = "loading";
      })
      .addCase(fetchUserStats.fulfilled, (state, action) => {
        state.userStats.status = "succeeded";
        state.userStats.data = action.payload;
      })
      .addCase(fetchUserStats.rejected, (state, action) => {
        state.userStats.status = "failed";
        state.userStats.error = action.error.message;
      });
      //  admin stats
    builder
      .addCase(fetchAdminStats.pending, (state) => {
        state.stats.status = "loading";
      })
      .addCase(fetchAdminStats.fulfilled, (state, action) => {
        state.stats.status = "succeeded";
        state.stats.data = action.payload;
      })
      .addCase(fetchAdminStats.rejected, (state, action) => {
        state.stats.status = "failed";
        state.stats.error = action.error.message;
      });
        //  graph stats
    builder
      .addCase(fetchDashGraph.pending, (state) => {
        state.graphStats.status = "loading";
      })
      .addCase(fetchDashGraph.fulfilled, (state, action) => {
        state.graphStats.status = "succeeded";
        state.graphStats.data = action.payload;
      })
      .addCase(fetchDashGraph.rejected, (state, action) => {
        state.graphStats.status = "failed";
        state.graphStats.error = action.error.message;
      });
         //  payments
    builder
      .addCase(fetchPaymentList.pending, (state) => {
        state.payments.status = "loading";
      })
      .addCase(fetchPaymentList.fulfilled, (state, action) => {
        state.payments.status = "succeeded";
        state.payments.data = action.payload;
      })
      .addCase(fetchPaymentList.rejected, (state, action) => {
        state.payments.status = "failed";
        state.payments.error = action.error.message;
      });
      //  complaints list
    builder
      .addCase(fetchComplaints.pending, (state) => {
        state.complaints.status = "loading";
      })
      .addCase(fetchComplaints.fulfilled, (state, action) => {
        state.complaints.status = "succeeded";
        state.complaints.data = action.payload;
      })
      .addCase(fetchComplaints.rejected, (state, action) => {
        state.complaints.status = "failed";
        state.complaints.error = action.error.message;
      });
      //  salon list for dummy booking
    builder
      .addCase(fetchBusiness.pending, (state) => {
        state.salonList.status = "loading";
      })
      .addCase(fetchBusiness.fulfilled, (state, action) => {
        state.salonList.status = "succeeded";
        state.salonList.data = action.payload;
      })
      .addCase(fetchBusiness.rejected, (state, action) => {
        state.salonList.status = "failed";
        state.salonList.error = action.error.message;
      });
       //  user list for dummy booking
    builder
      .addCase(fetchUser.pending, (state) => {
        state.userList.status = "loading";
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.userList.status = "succeeded";
        state.userList.data = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.userList.status = "failed";
        state.userList.error = action.error.message;
      });
  },
});

export default adminSlice.reducer;
